import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('set_up_twofactor_authen_n_for_enhanced_security'),
    descriptionAdministratorEnforcement: defineMessage('due_to_the_new_xero_req__up_as_soon_as_possible'),
    descriptionCompanyEnforcement: defineMessage('your_organisations_admi__up_as_soon_as_possible'),
    button: defineMessage('set_up_twofactor_authentication_1'),
    moreInformation: defineMessage('for_more_information_pl_support_teamsupportlink'),
};
